module.exports = __webpack_public_path__ + "img/building.28b2dc29.jpg";